import { z } from 'zod'

export const getDataWrapperSchema = <T extends z.ZodType>(dataSchema: T) => {
  const schema = z.object({
    data: dataSchema,
  })
  return schema.transform((result: { data?: z.output<T> }) => {
    const data = result.data
    if (data === null || data === undefined) {
      throw new Error('Data is null or undefined')
    }
    return data
  })
}
